// extracted by mini-css-extract-plugin
export default {"footer":"ConfirmModal-module--footer--EC01N"};